import styled from 'styled-components';
import { ConfirmButton, CancelButton } from 'components/ui/Button';

import { colours } from 'themes/default';

export const ErrorMessage = styled.div`
  color: red;
`;

export const StyledConfirmButton = styled(ConfirmButton)`
  margin-left: 16px;
`;

export const StyledCancelButton = styled(CancelButton)`
  margin-left: 16px;
`;

export const AppliedDiscountContainer = styled.div`
  display: inline-flex;
  margin-top: 8px;
  button {
    margin: 0;
    border-radius: 0 5px 5px 0;
  }
`;

export const AppliedDiscountCodeContainer = styled.div`
  display: inline-flex;
  border-top: 1px solid ${colours.Messaging.SuccessGreen};
  border-bottom: 1px solid ${colours.Messaging.SuccessGreen};
  border-left: 1px solid ${colours.Messaging.SuccessGreen};
  border-radius: 5px 0 0 5px;
  padding: 0 8px;
  align-items: center;
`;

export const DiscountFormContent = styled.div`
  display: flex;
  align-items: center;
`;

export const SuccessIconWrapper = styled.div`
  display: inline-block;
  margin-right: 8px;
  line-height: 0;
`;
